<template>
  <div class="side-by-side-submenu bg-bgDefault">
    <div class="side-by-side-submenu-container">
      <div class="inner w-50 px-8">
        <v-col class="left-column">
          <EstimatedCandidatesDropdown
            class="mr-6"
            :job-id="jobId"
            :specificity-key="specificityKey"
            :specificity-data="specificityData"
          />
          <TotalApplicantsTooltip
            class="mr-6"
          />
          <WordCount
            class="mt-auto mb-auto"
            :word-count="wordCount"
          />
        </v-col>
        <v-col class="right-column">
          <SideBySideSubMenuButtons
            :job-id="jobId"
            @tracking-event="$emit('tracking-event', $event)"
          />
        </v-col>
      </div>
    </div>
  </div>
</template>

<script>
import EstimatedCandidatesDropdown from '@/components/editor/EstimatedCandidatesDropdown.vue';
import WordCount from '@/components/editor/WordCount.vue';
import SideBySideSubMenuButtons from '@/components/editor/SideBySideSubMenuButtons.vue';
import TotalApplicantsTooltip from '@/components/editor/TotalApplicantsTooltip.vue';

export default {
  name: 'SideBySideSubMenu',
  components: {
    EstimatedCandidatesDropdown,
    TotalApplicantsTooltip,
    SideBySideSubMenuButtons,
    WordCount,
  },
  props: {
    jobId: { type: [Number, String], default: null },
    wordCount: { type: Number, default: null },
    specificityKey: { type: Number, default: 0 },
    specificityData: { type: Object, default: () => ({}) },
  },
  emits: ['tracking-event'],
};
</script>
<style scoped lang="less">
.side-by-side-submenu {
  height: 57px;
  z-index: 8;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: auto;
}
.side-by-side-submenu-container {
  display: flex;
  justify-content: flex-end;
  height: 100%;
  margin: 0 auto;
  .inner {
    display: flex;
    justify-content: space-between;
  }
  .left-column {
    display: flex;
    justify-content: flex-start;
    padding: 12px 0;
  }
  .right-column {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 12px 0;
    .v-btn {
      font-size: 16px;
    }
  }
}
</style>
